import Badge from "@mui/material/Badge"
import {styled} from "@mui/material/styles"

export const ShoppingBagBadge = styled(Badge)`
    .MuiBadge-badge {
        background: ${({theme}) => theme.uxfabric.components.badge.primary.backgroundColor};
        color: #fff;
        min-width: 1rem;
        height: 1rem;
        border-radius: 50%;
        font-size: 0.625rem;
        top: 0.175rem;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
    }
`
